import yieldLadderEn from './yieldLadder.en'
import rulesSecurityEn from './rulesSecurity.en'

export default function createLendingBundle(whitepaper) {
  return {
    lendingContent: {
      yieldLadder: yieldLadderEn,
      whitepaper,
      rulesSecurity: rulesSecurityEn
    }
  }
}
